import { Button } from '@mantine/core';
import { modals } from '@mantine/modals';
import { IconUserShare } from '@tabler/icons-react';
import { iconProps } from 'components/icon-props';
import { usePackage } from 'init/use-company-configuration';
import { tKeys, useTranslation } from 'locales';
import InviteCollaboratorForm from 'modules/Settings/Collaborators/InviteCollaboratorForm';
import { filter, prop } from 'remeda';
import type { useLoadUsers } from 'shared/hooks/use-load-users';

type InviteCollaboratorButtonProps = {
  users: NonNullable<ReturnType<typeof useLoadUsers>['users']>;
};

export const InviteCollaboratorButton = ({ users }: InviteCollaboratorButtonProps) => {
  const { t } = useTranslation();
  const { allowed_users_count } = usePackage();

  const openInviteModal = () =>
    modals.open({
      title: t(tKeys.FORM.INVITE_STAFF.TITLE),
      centered: true,
      children: <InviteCollaboratorForm onClose={modals.closeAll} />,
    });

  const activeUserCount = filter(users, prop('isActive')).length;
  const canInviteMore = activeUserCount < (allowed_users_count ?? 0);

  return (
    <Button
      onClick={openInviteModal}
      leftSection={<IconUserShare {...iconProps()} />}
      disabled={!canInviteMore}
    >
      {t(tKeys.INVITE)}
    </Button>
  );
};
